import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  Nav,
  NavItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardBody,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { addStep, clearStep } from '../actions/Breadcrumbs';
import { epikBoxesCompanyFilter } from '../actions/EpikBoxes';
import { masterBoxPressCall } from '../actions/Users';
import { useSelector, useDispatch } from 'react-redux';
import NotificationsBell from './NotificationsBell';
import { getPermissionForComponent } from '../utils/permissionsUtils';
import { canAccessNotifications } from '../lib/utils';
import { ReactComponent as HelpIcon }  from '../../src/Res/svg/help.svg'
import './Navigation.css';

const { REACT_APP_WAREHOUSE_SERVER, REACT_APP_NOCWIZARD_SERVER,REACT_APP_EPIKPLATFORM_SERVER, REACT_APP_TC_TOOLS, REACT_APP_PM_TOOLS } = process.env
const cardBody = { paddingTop: 0, paddingBottom: 0, paddingHorizontal: 10, background: 'white', paddingLeft: 16, borderBottom: '1px solid #ddd' };

const canAccessReports = user => {
  return (
    (user.role === 'superAdmin' ||
      user.role === 'companyGroupAdmin' ||
      user.role === 'admin' ||
      user.role === 'enterpriseAdmin') &&
    user.company.companyType !== 'manufacturer' &&
    user.role !== 'supportEngineer'
  );
};

const canAccessUsage = user => {
  return user.company.companyType !== 'manufacturer';
};

const canAccessUsers = user => {
  return (
    user.company.companyType !== 'manufacturer' &&
    user.role !== 'quoteToolAdmin' &&
    user.role !== 'agent' &&
    user.role !== 'user' &&
    user.role !== 'supportEngineer'
  );
};

const canAccessCompanies = user => {
  return (
    user.company.companyType !== 'manufacturer' &&
    user.role !== 'supportEngineer' &&
    (user.role === 'superAdmin' ||
      user.role === 'companyGroupAdmin' ||
      user.role === 'companyGroupManager')
  );
};

const isGeneralAdmin = user => {
  return (
    user.role === 'admin' ||
    user.role === 'enterpriseAdmin' ||
    user.role === 'companyGroupManager' ||
    user.role === 'superAdmin' ||
    user.role === 'companyGroupAdmin' ||
    user.role === 'supportEngineer'
  );
};

const canAccessCarrierHub = user => {
  return (
    user.company.companyType !== 'manufacturer' &&
    (user.role === 'superAdmin' ||
      user.role === 'companyGroupAdmin' ||
      user.role === 'supportEngineer')
  );
};

const canAccessVoicemail = user => {
  return (
    user.company.companyType !== 'manufacturer' &&
    user.role !== 'agent' &&
    user.role !== 'supportEngineer'
  );
};

const Bio = ({ email, first, last, company }) => {
  const username = first && last ? `${first} ${last}` : email;
  return (
    <Card color="light" style={{ margin: 0, border: 0 }}>
      <CardBody style={cardBody}>
        <span style={{ fontWeight: 'normal', whiteSpace: 'nowrap' }}>Signed in as&nbsp;</span>
        <strong>{username}</strong>
        <div className='d-flex align-items-center justify-content-center mt-2 mb-1'>
          <span style={{ fontWeight: 'normal', whiteSpace: 'nowrap' }}>Company:&nbsp;</span>
          <strong>{company || 'N/A'}</strong>
        </div>

      </CardBody>
    </Card>
  );
};

const MyDropdownToggle = ({ children }) => {
  return (
    <DropdownToggle nav className="nav-link text-left">
      {children}
      <FontAwesomeIcon icon="caret-down" className="ml-1" size="sm" style={{ color: '#8998ac' }} />
    </DropdownToggle>
  );
};

const isMainMenuVisibleTo = user => {
  return user?._id && !user.resetPassword;
};

const Navigation = ({ user, onLogout }) => {
  const dispatch = useDispatch();

  const eventsAccess = getPermissionForComponent('eventsAccess',user.permissionsGroup);
  const numberCarrierChangeAccess = getPermissionForComponent('numberCarrierChangeAccess',user.permissionsGroup);
  const warehouseQcAccess = getPermissionForComponent('warehouseQcAccess',user.permissionsGroup);
  const pcapModulePermission = getPermissionForComponent('pcapModulePermission',user.permissionsGroup);
  const nocWizardAccess = getPermissionForComponent('nocWizardAccess',user.permissionsGroup);
  const dataCenterMonitor = getPermissionForComponent('dataCenterMonitor',user.permissionsGroup);
  const tcToolsAccess = getPermissionForComponent('tcToolsAccess', user.permissionsGroup);
  const OOBMAssignment = getPermissionForComponent('OobmAccess', user.permissionsGroup);
  const wikiAccess = getPermissionForComponent('wikiAccess',user.permissionsGroup);
  const epikPlatform = getPermissionForComponent('epikPlatform',user.permissionsGroup);
  console.log('mian epikPlatform',epikPlatform);
  
  const customTemplate = getPermissionForComponent('customTemplate',user.permissionsGroup);
  console.log('mian customTemplate',customTemplate);
  


  const defaultOnClick = () => {
    return dispatch(epikBoxesCompanyFilter({}));
  };
  const userID = useSelector(state => state.AppState.user._id);

  const MyNavLink = ({ children, href, onClick = defaultOnClick, target }) => {
    // Size all links around bold widths so surrounding links won't jitter.
    const content = (
      <div className="text-center">
        <div style={{ position: 'relative', float: 'left' }}>{children}</div>
        <div style={{ opacity: 0, fontWeight: 'bold' }}>{children}</div>
      </div>
    );

    // If target is specified (e.g., "_blank"), use regular anchor tag instead of NavLink
    if (target) {
      return (
        <a href={href} target={target} rel={target === '_blank' ? 'noopener noreferrer' : undefined} onClick={onClick} className="nav-link">
          {content}
        </a>
      );
    }

    return (
      <NavLink to={href} onClick={onClick} className="nav-link">
        {content}
      </NavLink>
    );
  };
  const onClickBoxes = () => {
    dispatch(clearStep());
    dispatch(addStep({ label: 'boxes', redirect: '/boxes' }));
    dispatch(epikBoxesCompanyFilter({}));
    global.boxDetailStatus = false;
    global.myEpik = 'Yes';
    dispatch(masterBoxPressCall(false));
  };

  return (
    <Nav navbar className="ml-auto">
      {isMainMenuVisibleTo(user) && (
        <>
          {(user?.role === 'superAdmin' || user?.role === "companyGroupAdmin" || user?.role === 'admin' ||
            warehouseQcAccess)
             && <UncontrolledDropdown nav inNavbar>
              <MyDropdownToggle>Admin Tools</MyDropdownToggle>
              <DropdownMenu right className="mb-2">
              <div className='admin-dropdown-scroll'>
                {(user?.role === 'superAdmin' || user?.role === 'companyGroupAdmin' || user?.role === 'admin') && 
                  <DropdownItem>
                    <MyNavLink href={`/system-log`}>System Log</MyNavLink>
                  </DropdownItem>
                }
                {(warehouseQcAccess === 'write' || warehouseQcAccess === 'both') && user?.role !== 'admin' &&
                  <DropdownItem>
                    <div
                      className="p-3"
                      color="light"
                      onClick={() => {
                        window.open(REACT_APP_WAREHOUSE_SERVER, 'blank');
                      }}
                    >
                      <span>Warehouse QC Wizard</span>
                    </div>
                  </DropdownItem>
                }
                {(nocWizardAccess === 'write' || nocWizardAccess === 'both') && user?.role !== 'admin' &&(
                  <DropdownItem>
                    <div
                      className="p-3"
                      color="light"
                      onClick={() => {
                        window.open(REACT_APP_NOCWIZARD_SERVER, 'blank');
                      }}
                    >
                      <span>NOC Wizard</span>
                    </div>
                  </DropdownItem>
                )}
                {tcToolsAccess && user?.role !== 'admin' && (
                  <DropdownItem>
                    <div
                      className="p-3"
                      color="light"
                      onClick={() => {
                        window.open(REACT_APP_TC_TOOLS, 'blank');
                      }}
                    >
                      <span>TC Tools</span>
                    </div>
                  </DropdownItem>
                )}
                {(pcapModulePermission === 'write' ||
                 pcapModulePermission === 'both') && user?.role !== 'admin' && (
                    <DropdownItem>
                      <MyNavLink href={`/pcap-lookup`}>PCAP Lookup</MyNavLink>
                    </DropdownItem>
                  )}
                {dataCenterMonitor && user?.role !== 'admin' && (
                  <DropdownItem>
                    <MyNavLink href={`/infrastructure`}>Data Center Monitor</MyNavLink>
                  </DropdownItem>
                )}
                {(eventsAccess === 'write' || eventsAccess === 'both' || eventsAccess === 'read') && user?.role !== 'admin' && (
                  <DropdownItem>
                    <MyNavLink href={`/servers`}>Events</MyNavLink>
                  </DropdownItem>)
                }
                  {((epikPlatform === 'write' || epikPlatform === 'both') || user?.epikEngineering) && (
                    <DropdownItem>
                      <div
                        className="p-3"
                        color="light"
                        onClick={() => {
                          window.open(REACT_APP_EPIKPLATFORM_SERVER, '_blank');
                        }}
                      >
                        <span>EPIK Monitoring Services</span>
                      </div>
                    </DropdownItem>
                  )}
                  {((customTemplate === 'write' || customTemplate === 'both')) && (
                   <DropdownItem>
                    <MyNavLink href={`/templates`}>Custom Template</MyNavLink>
                  </DropdownItem>
                  )}
                </div>
              </DropdownMenu>
            </UncontrolledDropdown>
          }
          <DropdownItem divider style={{ marginTop: 0 }} />
          {canAccessReports(user) && (
            <NavItem>
              <MyNavLink href="/reports">Reports</MyNavLink>
            </NavItem>
          )}
          {canAccessUsage(user) && (
            <UncontrolledDropdown nav inNavbar id="usage-tab">
              <MyDropdownToggle>Usage</MyDropdownToggle>
              <DropdownMenu left={true}>
                {/* Commenting the code for future use. */}
                {
                  <DropdownItem>
                    <MyNavLink href="/calls">Calls</MyNavLink>
                  </DropdownItem>
                }
                {user.role !== 'agent' && user.role !== 'quoteToolAdmin' && (
                  <DropdownItem>
                    <MyNavLink href="/legacy-fax">Legacy Fax</MyNavLink>
                  </DropdownItem>
                )}
                {user.role !== 'agent' && user.role !== 'quoteToolAdmin' && (
                  <DropdownItem>
                    <MyNavLink href="/fax">Fax</MyNavLink>
                  </DropdownItem>
                )}
                {isGeneralAdmin(user) && (
                  <DropdownItem id="number-tab">
                    <MyNavLink href="/numbers">Numbers</MyNavLink>
                  </DropdownItem>
                )}
                {OOBMAssignment && (
                <DropdownItem id="oobm-tab">
                  <MyNavLink href="/oobm">OOBM</MyNavLink>
                </DropdownItem>
                )}
              </DropdownMenu>
            </UncontrolledDropdown>
          )}
          {canAccessUsers(user) && (
            <NavItem>
              <MyNavLink href="/users">Users</MyNavLink>
            </NavItem>
          )}
          {canAccessCompanies(user) && (
            <NavItem id="companies-tab">
              <MyNavLink href="/companies">Companies</MyNavLink>
            </NavItem>
          )}
          {isGeneralAdmin(user) && (
            <NavItem id="edge-devices-tab">
              <MyNavLink href="/boxes" onClick={onClickBoxes}>
                Edge Devices
              </MyNavLink>
            </NavItem>
          )}
          {canAccessVoicemail(user) && (
            <NavItem>
              <MyNavLink href="/vmails">Voicemail</MyNavLink>
            </NavItem>
          )}
          {canAccessCarrierHub(user) && (
            <NavItem>
              <MyNavLink href="/provisioning/new-number">Carrier Hub</MyNavLink>
            </NavItem>
          )}

          <UncontrolledDropdown nav inNavbar>
            <MyDropdownToggle>Account</MyDropdownToggle>
            <DropdownMenu right className="mb-2">
              <div className="d-none d-sm-block">
                <Bio
                  email={user.email}
                  company={user?.company?.name}
                  first={user.firstname}
                  last={user.lastname}
                />
              </div>
              <DropdownItem>
                <MyNavLink href="/profile">Profile</MyNavLink>
              </DropdownItem>
              <DropdownItem>
                <MyNavLink href={`/login-history?userID=${userID}`}>Login history</MyNavLink>
              </DropdownItem>
              <DropdownItem>
                <MyNavLink href="#" onClick={onLogout}>
                  <span style={{ fontWeight: 'normal' }}>Log out</span>
                </MyNavLink>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
          {(wikiAccess === 'write' || wikiAccess === 'both') && (
          <NavItem>
            <MyNavLink href="/apps/kb" target="_blank">
              <HelpIcon width={25} height={25} />
            </MyNavLink>
          </NavItem>
          )}

          {canAccessNotifications(user?.role) && <NotificationsBell />}

        </>
      )}
    </Nav>
  );
};

export default Navigation;
